<template>
    <div class="content">
        <Header></Header>
        <div class="top-message">
            <h1>RitsBookの使い方</h1>
        </div>
        <div class="guide">
            <div class="about">
                <p>RitsBookは立命館大学BKC生向けの教科書フリマアプリです。簡単3ステップの出品・購入で教科書を売買しよう！</p>
                <p>教科書が売れたり、教科書を買ったときは取引相手と取引日時と場所を相談して決めてください。</p>
                <p>そして当日、取引相手と商品と代金の交換が成立したら取引完了です！</p>   
            </div>
            <img src="../assets/売るときの3ステップ.png" alt=""><br>
            <img src="../assets/買うときの3ステップ.png" alt=""><br>
            <img src="../assets/買った・売れたときの3ステップ.png" alt="">
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'

export default {
    components: {Header, Footer}
}
</script>


<style scoped>
    .guide {
        text-align: center;
    }

    .about {
        margin: 0 auto;
        text-align: left;
        width: 50%;
    }

    img {
        width: 50%;
    }

@media all and (max-width:670px){
    img {
        width: 95%;
    }

    .about {
        width: 90%;
    }
}
</style>
